
import React from 'react';

const ButtonAcceptNT = ({ onAcceptConfirm, isDisabled = false }) => (
  <button className="btn btn-bright btn-md2 mb15 ml10" type="button" disabled={isDisabled} onClick={onAcceptConfirm}>Accept</button>
);

export default ButtonAcceptNT;
